import React from 'react';
import { useSelector } from 'react-redux';

import Tab from '@/views/components/Tab/Tab';
import useWindowIsMobile from '@/utils/hooks/useWindowIsMobile';

import styles from '@/views/pages/Template/Template.module.scss';

const TemplateCreateFormWrapper = ({children, mode}) => {
	const { dict } = useSelector((state) => state.app);

	const isMobile = useWindowIsMobile(991);

	return (
		<div className='letter__text--container'>
			{ !isMobile &&<div className='letter__text--header noselect'>
				<div className='letter__text--mode-selector'>
					<Tab
						isBtn={ false }
						isTabActive={ true }
						onClickHandler={ () => {} }
						value='createFormMode'
						label={ mode === 'EDIT_MODE' ? dict.templates.create.updateTemplateHeader : dict.templates.create.createTemplateHeader }
						style={ { borderRight: 'none' } }
					/>
				</div>
			</div>}
			<div className={ styles['form-wrapper'] }>
				{children}
			</div>
		</div>
	);
};

export default TemplateCreateFormWrapper;